import { ContestEntryDTO } from "./dtos";
import { TeamDO } from "./TeamDO";

export class ContestEntryDO {
	public id:number;
	public dateString:string;
	public points:number;
	public teamId:number;
	public team:TeamDO;
	
	public static fromContestDto(dto:ContestEntryDTO):ContestEntryDO {
		let cdo = new ContestEntryDO();
		cdo.id = dto.id;
		cdo.dateString = dto.dateString;
		cdo.points = dto.points;
		cdo.teamId = dto.teamId;
		cdo.team = TeamDO.fromTeamDto(dto.teamDto);
		
		return cdo;
	}
}